module.exports = __webpack_public_path__ + "static/media/resham2.3045c1ec.jpg";